import { ReactNode } from 'react';

import InviteJobseekerToJobModal from '../components/InviteJobseekerToJobModal/InviteJobseekerToJobModal';

interface UseJobseekerActionsProps {
  jobseekerId: string;
  setActiveComponent: React.Dispatch<React.SetStateAction<ReactNode>>;
}

const useJobseekerActions = ({
  jobseekerId,
  setActiveComponent
}: UseJobseekerActionsProps): {
  inviteJobseekerToJob: () => void;
  jobseekerInviteModalComponent: JSX.Element;
} => {
  const inviteJobseekerToJob = () => {
    if (!jobseekerId) {
      return;
    }

    setActiveComponent(jobseekerInviteModalComponent);
  };

  const handleCancelInvite = () => {
    setActiveComponent(null);
  };

  const jobseekerInviteModalComponent = (
    <InviteJobseekerToJobModal
      jobseekerId={jobseekerId}
      onCancel={handleCancelInvite}
    />
  );

  return { inviteJobseekerToJob, jobseekerInviteModalComponent };
};

export default useJobseekerActions;
